var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecord = function SvgRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.478 14.5v-2.174A5.855 5.855 0 0 1 .247 7.597l-.044-.26L.2 7.233a.521.521 0 0 1 1.01-.147l.026.102.035.214A4.815 4.815 0 0 0 6 11.308l.215-.005a4.815 4.815 0 0 0 4.548-4.116.52.52 0 1 1 1.03.15 5.855 5.855 0 0 1-5.273 4.99V14.5a.521.521 0 0 1-1.041 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.984 8.485c.526-.526.822-1.24.822-1.985V3.453A2.807 2.807 0 0 0 6.276.66L6 .646a2.806 2.806 0 0 0-2.806 2.807V6.5a2.807 2.807 0 0 0 4.79 1.985Z"
  })));
};
export default SvgRecord;